import {actionIds, BaseAction} from "../common";

const unsetReportsActivityAction: () =>
    BaseAction = () => ({
    type: actionIds.UNSET_REPORTS_ACTIVITY,
    payload: {}
});

export default unsetReportsActivityAction;